import React from "react";

const styles = {
  fontSize: "40px",
  fontWeight: "200",
};

const greyStyle = {
  fontSize: "20px",
  fontWeight: "600",
  backgroundColor: "#f7f7f7",
  border: "1px solid #e2e2e2",
  padding: "1rem",
  lineHeight: "1.6",
};

const FormTitle = ({ coloring, text, children, formRef }) => (
  <h1
    style={coloring === "grey" ? greyStyle : styles}
    tabIndex={0}
    // Sets ref for setFormFocus, make forms keyboard navigable
    ref={formRef}
  >
    {
      //if pagTitle is the properpty value (new schema) use text,
      // else if it's the old schema use (no color    ing) name
    }
    {text ? text : children}
  </h1>
);

export default FormTitle;
